import { render, staticRenderFns } from "./TicketChatColumn.vue?vue&type=template&id=ca449878&scoped=true"
import script from "./TicketChatColumn.vue?vue&type=script&lang=js"
export * from "./TicketChatColumn.vue?vue&type=script&lang=js"
import style0 from "./TicketChatColumn.vue?vue&type=style&index=0&id=ca449878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca449878",
  null
  
)

export default component.exports